module.exports = __webpack_public_path__ + "img/ba.860c9f4c.png";